import { useLocation } from 'react-router-dom';
import { identifyUser, identifyGroup, trackPage } from '@studio/analytics';
import { useAuth, useGraphQLQuery } from 'studio5/contexts';

import useIdentifier from './use-identifier';
import { GetAnalyticsTraitsQuery } from './__generated__/queries.types';
import { GET_ANALYTICS_TRAITS } from './queries';

export default () => {
  const [{ fetching, data }] = useGraphQLQuery<GetAnalyticsTraitsQuery>({
    query: GET_ANALYTICS_TRAITS,
  });

  const { isSpoofing } = useAuth();

  const { key: location } = useLocation();

  return useIdentifier({
    data,
    fetching,
    isSpoofing,
    location,
    onUserChange: (id: string, traits: object) =>
      identifyUser({
        id,
        traits: traits as Record<string, string | number | boolean>,
      }),
    onGroupChange: (id: string, traits: object) =>
      identifyGroup(id, traits as Record<string, unknown>),
    onPageChange: (pageName?: string) => trackPage(pageName),
  });
};
